module.exports = __webpack_public_path__ + "img/prevencionLaRioja.aecd311c.jpg";